/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from "react";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { Box, Grid, Typography } from "@mui/material";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { getAPICall } from "lib/callApi";
import "./styles/widget.scss";

export default function BaseWidget({ widget, renderData }) {
  const [widgetData, setWidgetData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { dataSource, displayName } = widget;

  const fetchWidgetData = async () => {
    try {
      const result = await getAPICall(dataSource, true);
      if (result?.data?.success) {
        setWidgetData(result.data.data);
        setError(null);
      } else {
        setError(result.data.message);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (dataSource) fetchWidgetData();
  }, [dataSource]);

  const shouldRenderData = !loading && !error;

  return (
    <Box p={2} className="baseWidget">
      <Box className="contentWrapper">
        <Typography variant="h6" color="info" className="title dragHandle">
          {displayName}
        </Typography>
        {error && (
          <Grid className="link-off-wrapper">
            <LinkOffIcon fontSize="large" />
          </Grid>
        )}
        {shouldRenderData && renderData(widgetData)}
      </Box>
    </Box>
  );
}
